<template>
    <div class="eaitor-tools">
        <button class="item-icon" v-for="(item, index) in iconList" :key="index" @click="change(item,index,'',$event)" v-bind:class="item.class">
            <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                <i :class="'iconfont el-icon-'+item.iconName">
                    <div class="choose-color" v-if="index==14 && cuttent == 14">
                        <div class="choose-color-drop">
                            <span v-for="(item,index) in colorList" :key='item.index' :index="index" @mousedown="changeColor('color',item.color)" :style="{background:item.color}">
                            </span>
                        </div>
                        <div class="down-arrow"></div>
                    </div>
                </i>
            </el-tooltip>
        </button>
    </div>
</template>

<script>
    import _ from 'lodash'
    export default {
        name: "EberTools",
        components: {},
        props: ['focusIndex','toolsClass'],
        data() {
            return {
                cuttent:-1,
                isActive:false,
                selectedRange: null,
                newSelectRange:[],
                choose: null,
                colorList:[
                    {color:'#333333'},
                    {color:'#9B9B9B'},
                    {color:'#ED2308'},
                    {color:'#FF8A00'},
                    {color:'#39B54A'},
                    {color:'#167EFB'},
                    {color:'#B06FBB'},
                ],
                iconList: [{
                    // hover名字
                    name: '撤销',
                    // 点击事件处理
                    type: 'undo',
                    iconName: 'tools701bianjiqi_chexiao',
                    class:""
                }, {
                    name: '粗体',
                    type: 'bold',
                    iconName: 'toolsbold',
                    class:""
                }, {
                    name: '斜体',
                    type: 'italic',
                    iconName: 'toolsitalic',
                    class:""
                }, {
                    name: '下划线',
                    type: 'underline',
                    iconName: 'tools705bianjiqi_Uxiahuaxian',
                    class:""
                }, {
                    name: '删除线',
                    type: 'strike',
                    iconName: 'tools707bianjiqi_shanchuxian',
                    class:""
                }, {
                    name: '正文',
                    type: 'p',
                    iconName: 'tools714bianjiqi_chunwenbenniantie',
                    class:""
                }, {
                    name: '小标题',
                    type: 'h5',
                    iconName: 'toolsyueduye_zitijianxiao',
                    class:""
                }, {
                    name: '标题',
                    type: 'h3',
                    iconName: 'tools728bianjiqi_zitidaxiao',
                    class:""
                }, {
                    name: '大标题',
                    type: 'h1',
                    iconName: 'toolsyueduye_zitizengda',
                    class:""
                }, {
                    name: '无序列表',
                    type: 'unorderedlist',
                    iconName: 'tools719bianjiqi_wuxuliebiao',
                    class:""
                }, {
                    name: '有序列表',
                    type: 'orderedlist',
                    iconName: 'tools718bianjiqi_youxuliebiao',
                    class:""
                }, {
                    name: '左对齐',
                    type: 'justifyLeft',
                    iconName: 'tools732bianjiqi_zuoduiqi',
                    class:"blue"
                }, {
                    name: '居中',
                    type: 'justifyCenter',
                    iconName: 'tools733bianjiqi_juzhongduiqi',
                    class:""
                }, {
                    name: '右对齐',
                    type: 'justifyRight',
                    iconName: 'tools734bianjiqi_youduiqi',
                    class:""
                }, {
                    name: '改色',
                    type: 'foreColor',
                    iconName: 'tools717bianjiqi_zitibeijingyanse',
                    class:""
                }]
            }
        },
        watch: {
            toolsClass:{
                handler(n){
                    if (_.isEqual(n,this.newSelectRange)) {
                        return
                    }
                    this.newSelectRange = [];
                    n.map(n => {
                        this.newSelectRange.push(n);
                    }); 
                    this.watchToolstyle();
                },
                deep:true,
                immediate:true
            }
        },
        methods: {
            // type工具栏类型
            change(item,index,content) {
                if(_.indexOf(this.newSelectRange,index)>-1){
                    _.pull(this.newSelectRange,index);
                }else{
                    this.changClassTools(index);
                }
                this.watchToolstyle();
                this.selectedRange = this.getSelect();
                this.restoreSelection();   
                this.changeStyle(item.type,content);// 修改所选区域的样式
                let ele = document.getElementById('paragraph_'+this.focusIndex);
                if(index == 9 || index == 10){
                    this.selectAllText(ele);
                }
                if(index == 14){
                    this.cuttent = 14;
                }
            },
             //改变tools的样式无序，有序（9.10）   对齐（11,12,13） 标题（6.7.8）
             changClassTools(index){
                let self = this;
                let list01 = [6,7,8];
                let list02 = [9,10];
                let list03 = [11,12,13];
                if(list01.indexOf(index)>-1){
                    _.pullAll(self.newSelectRange,list01).push(index);
                }else if(list02.indexOf(index)>-1){
                    _.pullAll(self.newSelectRange,list02).push(index);
                }else if(list03.indexOf(index)>-1){
                    _.pullAll(self.newSelectRange,list03).push(index);
                }else{
                    self.newSelectRange.push(index);
                }
            },
            watchToolstyle(){
                let self = this;
                Object.keys(self.iconList).map(key => self.iconList[key].class = '');
                if(!_.isEmpty(self.newSelectRange)){
                    for(let i = 0;i<self.newSelectRange.length;i++){
                        for(let j=0;j<self.iconList.length;j++){
                            if(j == self.newSelectRange[i]){
                                self.iconList[j].class="blue";
                            }
                        }
                    }
                }
            },
            changeColor(color,content){
                this.cuttent = 14;
                this.changeStyle(color,content);// 修改所选区域的样式
                if(this.selectedRange.startContainer.nodeName == 'LI'){
                   this.selectedRange.startContainer.style.color = content;
                }
            },
            // 获取选中
            getSelect() {
                if (window.getSelection) {
                    // 主流的浏览器，包括chrome、Mozilla、Safari
                    let sel = window.getSelection();
                    if (sel.rangeCount > 0) {
                        return sel.getRangeAt(0)
                    }
                } else if (document.selection) {
                    // IE下的处理
                    return document.selection.createRange()
                }
                return null
            },
            // 恢复光标位置
            restoreSelection() {
                const selection = document.getSelection();
                if (this.selectedRange) {
                    try {
                       selection.removeAllRanges() // 清空所有Range对象
                    } catch (ex) {
                        // IE
                        document.body.createTextRange().select()
                        document.selection.empty()
                    }
                    // 恢复保存的范围
                    selection.addRange(this.selectedRange);
                }
            },
             //光标在末尾
            selectAllText(elem) {
                if (window.getSelection) {
                    elem.focus();
                    var range = window.getSelection();
                    range.selectAllChildren(elem);
                    range.collapseToEnd();
                } else if (document.selection) {
                    var range = document.selection.createTextRange();
                    range.moveToElementText(elem);
                    range.collapse(false);
                    range.select(); /*避免产生空格*/
                }
            },
            // 改变选取的内容
            changeStyle(type,content) {
                switch (type) {
                    // 撤销
                    case 'undo':
                        document.execCommand('undo', false);
                        document.getElementById('paragraph_'+this.focusIndex).click();
                        break
                        //加粗
                    case 'bold':
                        document.execCommand('bold', false)
                        break
                        // 下划线。
                    case 'underline':
                        document.execCommand('underline', false)
                        break
                        // 删除线。
                    case 'strike':
                        document.execCommand('strikeThrough', false)
                        break
                        // 斜体。
                    case 'italic':
                        document.execCommand('italic', false)
                        break
                        //无序列表
                    case 'unorderedlist':
                        document.execCommand('insertUnorderedList', false)
                        break
                        //有序列表
                    case 'orderedlist':
                        document.execCommand('insertorderedList', false)
                        break
                    case 'h1':
                    case 'h3':
                    case 'h5':
                    case 'p':
                        document.execCommand('formatBlock', false, type)
                        break
                    case 'justifyCenter':
                    case 'justifyFull':
                    case 'justifyLeft':
                    case 'justifyRight':
                        document.execCommand(type, false)
                        break
                    //颜色
                    case 'color':
                        this.cuttent = 15
                        document.execCommand('foreColor', false, content);
                        break
                    default:
                }
            }
        }
    }
</script>
<style>
     .eaitor-tools{
        width:90%;
        height: 40px;
        line-height: 44px;;
        background: #fff;
        border-bottom:1px solid #d4dadf;
        padding: 0 5%;
        margin-bottom: 10px;
    }
    .eaitor-tools button {
        position: relative;
        border: none;
        font-size: 20px;
        color: grey;
        background: #fff;
        padding: 0px 7px;
    }
    .eaitor-tools .blue{
        color: #2f92ff;
    }
    .choose-color{
        position: absolute;
        width: 200px;
        left: -150px;
        top:30px;
        background: #fff;
        border-radius: 4px;
        border: 1px solid #e8eaed;
        padding: 12px;
        z-index: 3024;
        color: #3b454e;
        line-height: 1.4;
        text-align: justify;
        font-size: 14px;
        -webkit-box-shadow: 0 2px 10px 0 rgba(59,69,78,.1);
        box-shadow: 0 2px 10px 0 rgba(59,69,78,.1);
    }
    .down-arrow{
        position: absolute;
        right: 54px;
        top: -6px;
        background: #fff;
    }
    .down-arrow:after{
        content: '';            
        display: block;            
        width: 10px;            
        height: 10px;            
        border-right: 1px solid #e8eaed;            
        border-top: 1px solid #e8eaed;            
        -webkit-transform: rotate(315deg); /*箭头方向可以自由切换角度*/            
        transform: rotate(315deg);
    }
    .choose-color-drop span{
        display: inline-block;
        width: 18px;
        height: 18px;
        border-radius: 50%;
        margin: 0 5px;
        cursor: pointer;
    }
    .el-submenu__title [class^=el-icon-] {
        color: #74818d;
        font-size: 16px;
        font-weight: 700;
        border: 1px solid #d3dce4;
        padding: 4px 0px;
        border-radius: 50%;
    }
    .el-submenu__title [class^=el-icon-]:hover {
        color: #2f92ff;
        background: #fff;
    }
    .el-submenu__title:hover {
        background-color: #fff;
    }
    .el-menu--vertical{
        top: 180px;
    }
    .el-menu--popup {
        min-width: 118px;
        border:1px solid #e8eaed;
    }
</style>